<template>
    <span
        class="sim-count-indicator-text"
        :class="{
            [`c-${color}`]: color !== 'basic',
        }"
        aria-hidden="true"
    >
        {{ `${count}${showX ? '×' : ''}` }}
    </span>
</template>

<script lang="ts" setup>
const {
    count,
    color = 'basic',
    showX,
} = defineProps<{
    count: number | null
    color?: 'basic' | 'simplo'
    showX?: boolean
}>()

</script>

<style lang="scss" scoped>
.sim-count-indicator-text {
    display: inline-block;

    padding: 0;

    background-color: unset;
    color: $sim-c-basic-500;

    font-size: inherit;
    border-radius: 0;

    &::before {
        content: '/';
        padding-right: 0.5rem;
    }
}

.c-simplo {
    color: $sim-c-simplo;
}

</style>
